import React, { useState, useEffect } from 'react'
import { domToReact } from 'html-react-parser'
import { useParams } from 'react-router-dom'
import moment from 'moment'

import { useGame, useEventData } from 'data/hooks'

const ops = {
  eq: '===',
  ne: '!==',
  gt: '>',
  lt: '<',
  ge: '>=',
  le: '<='
}


export const ControlledContent = props => {

  const [isVisible, visible] = useState(false)
  const [rules, setRules] = useState(null)

  const gameId = useParams().gameId || playmotiv.game.gameId
  const { eventId } = useParams()

  const { kpis, data, player, user } = useGame(gameId)
  const eventData = useEventData(gameId, eventId)

  const evalrules = () => {

    const evaluation = rules
      .reduce((result, rule) => {

        let e = false
        const key = rule[0]
        let op, value, expr, r, k

        switch (key) {

          case 'userdata':
            r = [...rule]
            r.shift()
            k = r.shift()
            value = r.pop()

            expr = `"${user.userData[k]}" === "${value}"`

            e = eval(expr);
            break;

          case 'player':
            
            r = [...rule]
            r.shift()
            k = r.shift()
            value = r.pop()

            expr = `"${player[k]}" === "${value}"`

            e = eval(expr);

            break;

          case 'context':
            /*
            const contextfield = contextfields[rule[1]] // Hack for lowercase in rules slug
            const data = window.playmotiv.context[contextfield]
            op = rule[2]
            value = rule[3]
            expr = data + ' ' + ops[op] + ' ' + value
              
            e = eval(expr)
            */
            break;

          case 'event':

            if (!eventId) return false

            const state = rule[1]
            const { instance } = eventData
            const { start, end, closed } = instance || {}

            const states = {
              started: instance && start && moment().isSameOrAfter(start) ? true : false,
              finished: instance && end && moment().isSameOrAfter(end) ? true : false,
              closed: instance && closed !== null ? true : false,
              running: instance && (
                start && moment().isSameOrAfter(start)
                &&
                (!instance.end || moment().isSameOrBefore(end))
              ) ? true : false
            }

            e = states[state]

            break

          case 'eventdata':

            r = [...rule]
            r.shift()

            value = eventData.instance.eventData

            r.forEach(key => {
              value = value && value[key] ? value[key] : undefined
            })

            e = value !== undefined

            break;

          case 'kpi':

            if (!eventId) return false

            r = [...rule]
            k = r.shift()
            value = r.pop()
            op = r.pop()

            const kpiId = r.join('_')
            const kpi = kpis[kpiId]
            const userKpiValue = eventData.kpis[kpiId]
            const kpiValue = userKpiValue ?
              kpi.aggregation !== 'NONE' ? parseFloat(userKpiValue) : userkpivalue
              :
              userKpiValue

            expr = kpiValue + ' ' + ops[op] + ' ' + value

            e = eval(expr)

            break

          case 'ranking':

            if (!eventId) return false

            r = [...rule]
            k = r.shift()
            value = r.pop()
            op = r.pop()

            const rankingId = r.join('_')
            const rankingData = eventData.rankings[rankingId]

            if (rankingData?.me) {

              const position = rankingData.me.position
              expr = position + ' ' + ops[op] + ' ' + value

              e = eval(expr)

            } else {
              
              e = false;
            }

            // console.log(rule, rankingId, value, op)
           

            break;

          case 'award':

            r = [...rule]
            k = r.shift()
            value = r.pop()
            op = r.pop()

            const awardType = r.join('_')

            if (op === 'contains') {

              const exists = data.awards.find(award => 
                award.awardType === awardType && award.value === value
              )

              e = (exists !== undefined)

            } else {

              const awardValue = data.awards.reduce((total, award) => {
                if (award.awardType === awardType) total += parseFloat(award.value)
                return total
              }, 0)

              expr = awardValue + ' ' + ops[op] + ' ' + value

              e = eval(expr)
            }

            break

          default:
            e = true
        }

        return result || e

      }, false)

    return evaluation
  }

  useEffect(() => {

    const parsedrules = props.attribs['data-rules']
      .split('|')
      .map(rule => rule.split('_'))

    setRules(parsedrules)

  }, [])

  useEffect(() => {

    visible(rules && data ? evalrules() : false)

  }, [rules, data, eventData])

  return isVisible ?
    <div className="controlledcontent" {...props.attribs}>
      {domToReact(props.children, { replace: props.replace })}
    </div>
    :
    <></>

}
